var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
		'error-icon': true,
		'error-icon--disabled': _vm.disabled,
		'error-icon--enabled': !_vm.disabled,
	}},[_c('font-awesome-icon',{attrs:{"icon":['fal', _vm.customIcon],"title":_vm.title,"size":"lg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }